import React from 'react';
import { DH } from '../../../utils/DataHook';
import { Modal, Overlay } from '../../ModalLayout';

interface FramedModalViewProps {
  url: string;
  width: number | string;
  height: number | string;
  isVisible: boolean;

  onClose(): void;
}

export const FramedModalView: React.FunctionComponent<FramedModalViewProps> = (
  props
) => (
  <Overlay
    dataHook={DH.FramedModal.Custom.FrameContainer}
    isVisible={props.isVisible}
    onClick={props.onClose}
  >
    <Modal width={props.width} height={props.height} onClose={props.onClose}>
      <iframe
        data-hook={DH.FramedModal.Custom.Frame}
        src={props.url}
        frameBorder="0"
        width="100%"
        height="100%"
      />
    </Modal>
  </Overlay>
);
FramedModalView.displayName = 'FramedModalView';
